import { render, staticRenderFns } from "./SaleTags.vue?vue&type=template&id=7321ec79&scoped=true"
import script from "./SaleTags.vue?vue&type=script&lang=js"
export * from "./SaleTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7321ec79",
  null
  
)

export default component.exports